import { SubscriptionPlanName } from '@sparemin/api-sdk';
import cn from 'classnames';
import * as React from 'react';

import { SubscriptionPeriod } from '../types';
import usePlanCost from '../usePlanCost';
import { block } from './utils';

type PlanOptions = Record<SubscriptionPeriod, SubscriptionPlanName>;

export interface CostDisplayProps {
  cost: Partial<PlanOptions> | string;
  period?: SubscriptionPeriod;
  isPrevious?: boolean;
  className?: string;
}

const CostDisplay: React.FC<CostDisplayProps> = ({
  cost,
  period,
  isPrevious,
  className,
}) => {
  const monthlyPlan = typeof cost === 'string' ? undefined : cost.monthly;
  const yearlyPlan = typeof cost === 'string' ? undefined : cost.yearly;

  const monthlyCost = usePlanCost(monthlyPlan, 'monthly');
  const yearlyCost = usePlanCost(yearlyPlan, 'monthly');

  const currentCost = period === 'monthly' ? monthlyCost : yearlyCost;
  const shouldShowSuffix = period === 'monthly' ? !!monthlyCost : !!yearlyCost;

  return (
    <span className={cn(block('amount', { previous: isPrevious }), className)}>
      {typeof cost === 'string' ? cost : currentCost}

      {shouldShowSuffix && <span className={block('monthly-suffix')}>/mo</span>}
    </span>
  );
};

export default CostDisplay;
